import React, { useEffect, useState } from "react";
import { Patient } from "../../services/getFunctions";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "react-bootstrap";
import { zipSurveyStatusAndStw } from "../../helper/surveyUtils";
import { SurveyStatusAndStws } from "../../types/surveyTypes";

interface SurveyStatusModalProps {
  currentPatient: Patient;
  modalSurveyStateOpen: boolean;
  closeSurveyStateModal: () => void;
}

const SurveyStatusModal = ({
  currentPatient,
  modalSurveyStateOpen,
  closeSurveyStateModal,
}: SurveyStatusModalProps) => {
  const [surveyStatusAndStws, setSurveyStatusAndStws] = useState<
    SurveyStatusAndStws[]
  >([]);

  const extractStwsArray = (stws: unknown) => {
    if (Array.isArray(stws)) {
      return stws;
    }
    if (stws && typeof stws === "object" && "stws" in stws) {
      return (stws as { stws: unknown }).stws;
    }
    return [];
  };

  useEffect(() => {
    if (!modalSurveyStateOpen || !currentPatient) {
      setSurveyStatusAndStws([]);
      return;
    }

    const { survey_statuses: surveyStatuses, survey_time_windows: stws } =
      currentPatient;

    const stwsArray = extractStwsArray(stws);

    const zippedSurveyStatusAndStws = zipSurveyStatusAndStw(
      stwsArray as Parameters<typeof zipSurveyStatusAndStw>[0],
      surveyStatuses,
    );

    setSurveyStatusAndStws(zippedSurveyStatusAndStws);
  }, [modalSurveyStateOpen, currentPatient]);

  if (!modalSurveyStateOpen) return null;

  return (
    <div>
      <Modal
        backdrop="static"
        show={modalSurveyStateOpen}
        onHide={closeSurveyStateModal}
      >
        <ModalHeader closeButton>
          <ModalTitle>
            Befragungsstatus von <em>{currentPatient.code}</em>
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          {surveyStatusAndStws.map((state) => {
            const key = state.stw_start;
            return (
              <div key={key}>
                {state.stw_type_deutsch} :{" "}
                <span
                  style={{
                    color: state.survey_status_color,
                    cursor: "default",
                  }}
                >
                  {state.survey_status}
                </span>
                <br />
              </div>
            );
          })}
        </ModalBody>
        <ModalFooter></ModalFooter>
      </Modal>
    </div>
  );
};

export default SurveyStatusModal;
